import DefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/DefaultDialogPage";
import {css} from "@emotion/css";
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import searchIcon from "../../assets/images/search-normal.svg";
import filterIcon from "../../assets/images/svg/document-filter.svg";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import * as React from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {useEffect, useState} from "react";
import {LoanRequestService} from "./LoanRequestService";
import {convertPersianDateToUniversalDate, convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import LoanRequestDetails from "./LoanRequestDetails";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

let selectedItemId = -1
const LoanRequestsList = () => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new LoanRequestService(fundID, token, snackbar, loading)


    const [userFullNameFilterText, setUserFullNameFilterText] = useState("");

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");


    const [selectedStartDateFilter, setSelectedStartDateFilter] = useState("");
    const [selectedEndDateFilter, setSelectedEndDateFilter] = useState("");
    const [accountNumber, setAccountNumber] = useState("");

    const [filterDialogOpenState, setFilterDialogOpenState] = useState(false);

    const [filterTitle, setFilterTitle] = useState("");


    useEffect(() => {
        if (typeof service !== 'undefined' && typeof accountNumber !== "undefined") {
            getPendingLoanRequestAmount()
            getListDataFromServer()
        }
    }, [])

    function getPendingLoanRequestAmount() {
        service.getPendingLoanRequestTotalAmount()
            .then(response => {
                setTotalAmount(response.summationsOfAwaitingForReview)
            }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت مجموع وام های در حال بررسی",
                snackbar,
                loading
            )
        })
    }


    const [pageCount, setPageCount] = useState(1);
    const [itemCount, setItemCount] = useState(5);

    const [costsAndRevenuesList, setCostsAndRevenuesList] = useState([]);

    const [needRefresh, setNeedRefresh] = useState(false);

    const [summation, setSummation] = useState("");

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    function getListDataFromServer(
        fullName = userFullNameFilterText,
        filterStartDate = selectedStartDateFilter,
        filterEndDate = selectedEndDateFilter,
        accountNumber) {

        loading(setLoadingStateDispatch(true))

        service.getLoanRequestsList(
            page,
            fullName,
            filterStartDate,
            filterEndDate,
            accountNumber,
        ).then((response) => {

            setResponseData(response)

            loading(setLoadingStateDispatch(false))
        }).catch(reason => {

            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست هزینه درآمد"))
            loading(setLoadingStateDispatch(false))
        })
    }

    function setResponseData(responseData) {
        setItemCount(responseData.numberOfItems)
        setPageCount(responseData.totalPage)
        setCostsAndRevenuesList([])
        setSummation(responseData.summationOfAmount)

        responseData.data.map((item, index) => {
            setCostsAndRevenuesList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 15) + index + 1,
                    item.firstName,
                    item.lastName,
                    item.sendAt,
                    item.depositAccountNumber,
                    item.amount,
                    item.numberOfInstallments,
                    item.loanKindPersianName,
                    item.status,
                )
            ])
        })
    }

    function prepareGroupsJsonList(
        id,
        number,
        firstName,
        lastName,
        sendAt,
        depositAccountNumber,
        amount,
        numberOfInstallments,
        kind,
        enabled) {
        return {
            id: id,
            number: number,
            firstName,
            lastName,
            sendAt: convertUniversalDateToPersianDate(sendAt),
            depositAccountNumber,
            amount: convertCurrencyFormat(amount),
            numberOfInstallments,
            kind,
            enabled: <div className={"d-flex flex-shrink-1 justifyContentCenter"}>
                {enabled === "AWAITING_FOR_REVIEW" ? <span
                        className="bg_default_state">در حال بررسی</span> :
                    enabled === "ACCEPTED" ?
                        <span
                            className="bg_active_state">پذیرفته شده</span> :
                        <span
                            className="bg_deActive_state">رد شده</span>}
            </div>,
        }
    }


    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setLoanRequestDetailPageOpenState(true)
    }


    function applyFilters() {
        if (checkFilters()) {
            setSelectedStartDateFilter(startDate)
            setSelectedEndDateFilter(endDate)

            getListDataFromServer(
                userFullNameFilterText,
                convertPersianDateToUniversalDate(startDate),
                convertPersianDateToUniversalDate(endDate))

            prepareFilterTitles()
            setFilterDialogOpenState(false)
        }
    }

    function checkFilters() {
        let status = false
        let message = ""
        if (startDate.length > 0 && startDate.length !== 10) {
            message = "تاریخ شروع وارد شده صحیح نمی باشد!"
        } else if (endDate.length > 0 && endDate.length !== 10) {
            message = "تاریخ پایان وارد شده صحیح نمی باشد!"
        } else {
            status = true
        }

        if (message.length > 0) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        }

        return status;
    }

    function prepareFilterTitles() {
        let _filterTitle = ""
        if (startDate.length > 0) {
            _filterTitle = `از تاریخ ${startDate} ، `
        }
        if (endDate.length > 0) {
            _filterTitle = `${_filterTitle}تا تاریخ ${endDate} ، `
        }

        if (_filterTitle.length > 0) {
            _filterTitle = `فیلتر ها : ${_filterTitle}`
        }

        setFilterTitle(_filterTitle)
    }


    function deleteFilters() {
        setSelectedStartDateFilter("")
        setSelectedEndDateFilter("")

        setStartDate("")
        setEndDate("")

        setFilterTitle("")

        getListDataFromServer(
            userFullNameFilterText,
            "",
            "")

        setFilterDialogOpenState(false)
    }

    const [searchSelectedValue, setSearchSelectedValue] = useState("full-name");


    function applySearch(searchText, searchType) {
        if (searchType === "full-name") {
            getListDataFromServer(searchText, selectedStartDateFilter, selectedEndDateFilter, "")
        } else {

            getListDataFromServer("", selectedStartDateFilter, selectedEndDateFilter, searchText)
        }
    }

    const [loanRequestDetailPageOpenState, setLoanRequestDetailPageOpenState] = useState(false);

    const [totalAmount, setTotalAmount] = useState("");

    return (
        <>
            <DefaultDialogPage
                onClose={_ => setFilterDialogOpenState(false)}
                open={filterDialogOpenState}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"فیلتر ها"}
            >
                <section className={css`display: flex;
                  flex-direction: column;
                  width: 100%;
                  gap: 16px;
                  padding: 0 16px 16px 16px;
                `}>
                    <TextField
                        value={convertToBirthDate(startDate)}
                        onChange={e => {
                            const _date = convertToBirthDate(e.target.value)
                            setStartDate(_date)
                        }}
                        className='w-100'
                        variant="outlined" label="فیلتر تاریخ ابتدا"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <TextField
                        value={convertToBirthDate(endDate)}
                        onChange={e => {
                            const _date = convertToBirthDate(e.target.value)
                            setEndDate(_date)
                        }}
                        className='w-100'
                        variant="outlined" label="فیلتر تاریخ انتها"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <section className={css`display: flex;
                      flex-wrap: nowrap;
                      gap: 16px;`}>
                        <Button className={"btn-confirm w-100"} onClick={applyFilters}>اعمال فیلتر</Button>
                        <Button className={"btn-secondary w-100"} onClick={deleteFilters}>پاک کردن</Button>
                    </section>
                </section>
            </DefaultDialogPage>

            <DefaultDialogPage
                onClose={_ => {

                    selectedItemId = -1
                    if (needRefresh) {
                        getListDataFromServer()
                    }
                    setLoanRequestDetailPageOpenState(false)
                }}
                open={loanRequestDetailPageOpenState}
                dialogSize={DialogSize.MEDIUM}
                pageTitle={"جزئیات درخواست وام"}>
                <LoanRequestDetails requestId={selectedItemId} needRefresh={setNeedRefresh}/>
            </DefaultDialogPage>

            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 .5rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'start', justifyContent: "start"}}>
                        <Typography variant={"h5"}>
                            درخواست های وام
                        </Typography>
                        {itemCount > 0 ?
                            <Typography className={css`margin: 8px 8px 0 0;`} variant={"caption"}>
                                {" " + itemCount + " درخواست ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                </Box>

                <div className="d-flex">
                    <Grid xs={12} className={`d-flex flex-row flex-wrap`}>

                        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className={`infoBoxContainer ${css`margin-bottom: 1.2rem;`}`}>
                                <span className={"fs-1"}>مجموع وام های در حال بررسی</span>
                                <span
                                    className={"fs-3"}>{totalAmount ? convertCurrencyFormatPositiveNegative(totalAmount) : "0"} ریال</span>
                            </div>
                        </Grid>

                        <Grid xs={12} sm={12} md={7} lg={8} xl={8}
                              className={css`display: flex;
                                flex-direction: row;
                                flex-wrap: nowrap;
                                gap: 8px;`}>
                            <TextField
                                value={userFullNameFilterText}
                                onChange={e => {
                                    const _name = e.target.value
                                    setUserFullNameFilterText(_name)
                                    applySearch(_name, searchSelectedValue)
                                }}
                                className='w-100'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={searchIcon} alt=""/>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined" label="جستجو بر اساس شماره حساب"
                                placeholder="شماره حساب مورد نظر را وارد نمایید..."/>
                        </Grid>
                        <Grid xs={12} sm={12} md={5} lg={4} xl={4}>
                            <div className={css`display: flex;
                              flex-direction: row;
                              margin-right: 8px;
                              gap: 8px;
                            `}>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                                    <Select label="جستجو بر اساس"
                                            value={searchSelectedValue}
                                            onChange={e => {
                                                setSearchSelectedValue(e.target.value)
                                                applySearch(userFullNameFilterText, e.target.value)
                                            }}>
                                        <option value={"full-name"}>نام و نام خانوادگی</option>
                                        <option value={"deposit-account-number"}>شماره حساب</option>
                                    </Select>
                                </FormControl>
                                <section className={css`
                                  background: #EBECF1 !important;
                                  border-radius: 10px !important;
                                  padding: 0 1rem;
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                  cursor: pointer;
                                `}
                                         onClick={_ => {
                                             setStartDate(selectedStartDateFilter)
                                             setEndDate(selectedEndDateFilter)

                                             setFilterDialogOpenState(true)
                                         }}
                                >
                                    <img src={filterIcon} alt={"filters"}/>
                                </section>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <span className={css`padding: .5rem 0;
                  font-size: 13px;
                  color: #3F4254;`}>
                    {filterTitle}
                </span>
                <CustomTable
                    header={columns}
                    data={costsAndRevenuesList}
                    rowClicked={showEventsContent}
                    summation={summation}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default LoanRequestsList;

const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'firstName',
        label: 'نام',
        align: 'right',
    },
    {
        id: 'lastName',
        label: 'نام خانوادگی',
        align: 'right',
    },
    {
        id: 'sendAt',
        label: 'تاریخ ارسال',
        align: 'right',
    },
    {
        id: 'depositAccountNumber',
        label: 'شماره حساب',
        align: 'right',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'numberOfInstallments',
        label: 'تعداد اقساط',
        align: 'right',
    },
    {
        id: 'kind',
        label: 'نوع وام',
        align: 'right',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
        align: 'right',
    },
];
